import api from '../../../shared/services/apiClient';
import { User } from '@/types';

export const getUsers = async (): Promise<User[]> => {
  const res = await api.get('/users');
  return res.data as User[];
};

export const getUserById = async (id: string | number): Promise<User | undefined> => {
  const res = await api.get(`/users/${id}`);
  return res.data as User;
};

export const createUser = async (data: Omit<User, 'id' | 'date' | 'createdBy'>): Promise<User> => {
  const res = await api.post('/users', data);
  return res.data as User;
};

export const updateUser = async (id: string | number, data: Partial<User>): Promise<User | undefined> => {
  const res = await api.put(`/users/${id}`, data);
  return res.data as User;
};

export const deleteUser = async (id: string | number): Promise<boolean> => {
  const res = await api.delete(`/users/${id}`);
  return res.status === 204 || res.status === 200;
};
